"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EventLabelCartErrorEnum = void 0;
var EventLabelCartErrorEnum;
(function (EventLabelCartErrorEnum) {
    EventLabelCartErrorEnum["InvoiceIsUnavailable"] = "Selected payment method not available_Invoice";
    EventLabelCartErrorEnum["CreditCardIsUnavailable"] = "Selected payment method not available_Creditcard";
    EventLabelCartErrorEnum["GooglePayIsUnavailable"] = "Selected payment method not available_GooglePay";
    EventLabelCartErrorEnum["ApplePayIsUnavailable"] = "Selected payment method not available_ApplePay";
    EventLabelCartErrorEnum["PayPalIsUnavailable"] = "Selected payment method not available_Paypal";
    EventLabelCartErrorEnum["AmazonPayIsUnavailable"] = "Selected payment method not available_AmazonPay";
    EventLabelCartErrorEnum["SofortIsUnavailable"] = "Selected payment method not available_Sofortueberweisung";
    EventLabelCartErrorEnum["FallbackPaymentAmazon"] = "FallbackPayment_Amazon";
    EventLabelCartErrorEnum["FallbackPaymentPaypal"] = "FallbackPayment_Paypal";
    EventLabelCartErrorEnum["FallbackPaymentStripe"] = "FallbackPayment_Stripe";
})(EventLabelCartErrorEnum || (exports.EventLabelCartErrorEnum = EventLabelCartErrorEnum = {}));
//# sourceMappingURL=EventLabelCartErrorEnum.js.map